"use client";

import { useState, useEffect, useMemo } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { baseUrl } from "../../config/baseUrl";
import axios from "axios";
import toastify from "../../config/toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faEdit,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import JoditEditor from "jodit-react";
import editorConfig from "../../utils/editorConfig";
export default function TestEdit() {
  const { id } = useParams();

  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchingTest, setFetchingTest] = useState(true);

  const [fetchingPackages, setFetchingPackages] = useState(false);

  const [testNotFound, setTestNotFound] = useState(false);
  const navigate = useNavigate();
  const [formval, setFormval] = useState({
    title: "",
    description: "",
    duration: "",
    marks: "",
    positiveMark: "",
    negativeMark: "",
    packageId: "",
    isFree: false,
    language: "English",
    pdfDownload: false,
    attemptLimit: "",
    status: "active",
    pdfFile: null,
  });
  useEffect(() => {
    fetchTestData();
    fetchPackages();
  }, [id]);

  const fetchTestData = async () => {
    try {
      setFetchingTest(true);
      const response = await axios.get(`${baseUrl}/test/${id}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });

      if (response.data.status) {
        const currentTest = response.data.data;

        if (currentTest) {
          setFormval({
            title: currentTest.title || "",
            description: currentTest.description || "",
            duration: currentTest.duration?.toString() || "",
            marks: currentTest.marks?.toString() || "",
            positiveMark: currentTest.positiveMark?.toString() || "",
            negativeMark: currentTest.negativeMark?.toString() || "",
            packageId: Array.isArray(currentTest.packageId)
              ? (currentTest.packageId[0]?._id || currentTest.packageId[0] || "")
              : (currentTest.packageId?._id || currentTest.packageId || ""),
            pdfDownload: currentTest.isFree || false,
            isFree: currentTest.pdfDownload || false,
            attemptLimit: currentTest.attemptLimit?.toString() || "",
            language: currentTest.language || "English",
            status: currentTest.status || "active",
            pdfFile: currentTest?.pdfFile || null,
          });
        } else {
          setTestNotFound(true);
          toastify.error("Test not found");
        }
      }
    } catch (error) {
      console.error("Error fetching test data:", error);
      toastify.error("Failed to fetch test data");
      setTestNotFound(true);
    } finally {
      setFetchingTest(false);
    }
  };

  const changeHandler = (e) => {
    const { name, value, type, checked } = e.target;
    setFormval((prevVal) => ({
      ...prevVal,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const fetchPackages = async () => {
    try {
      setFetchingPackages(true);
      const response = await axios.get(`${baseUrl}/package`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      if (response.data.status) {
        setPackages(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching packages:", error);
    } finally {
      setFetchingPackages(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formval.title) return toastify.error("Title is required");
    if (!formval.description) return toastify.error("Description is required");

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("title", formval.title);
      formData.append("description", formval.description);
      formData.append("duration", formval.duration);
      formData.append("marks", formval.marks);
      formData.append("positiveMark", formval.positiveMark);
      formData.append("negativeMark", formval.negativeMark);
      formData.append("packageId", formval.packageId || "");
      formData.append("language", formval.language);
      formData.append("pdfDownload", formval.pdfDownload);
      formData.append("isFree", formval.isFree);
      formData.append("attemptLimit", formval.attemptLimit || 1);
      formData.append("status", formval.status);

      // Agar naya pdf file select hua hai
      if (formval.pdfFile) {
        formData.append("pdfFile", formval.pdfFile);
      }

      const response = await axios.put(`${baseUrl}/test/${id}`, formData, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.status) {
        toastify.success("Test updated successfully");
        navigate("/test-series");
      } else {
        toastify.error(
          response.data.message || "An error occurred while updating test"
        );
      }
    } catch (error) {
      console.error("Error:", error);
      toastify.error(error.response?.data?.message || "Failed to update test");
    } finally {
      setLoading(false);
    }
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormval((prev) => ({
        ...prev,
        pdfFile: file, // abhi naya file object store hoga
      }));
    }
  };
  // Editor config ko memoize karein taaki re-render hone par ye change na ho
  const config = useMemo(() => ({
    ...editorConfig,
    placeholder: "Enter test description",
  }), []);
  if (fetchingTest) {
    return (
      <section className="main-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="cards">
                <div className="loading-message">
                  <div
                    className="loading-spinner"
                    style={{ display: "inline-block" }}
                  ></div>
                  <span className="ms-2">Loading test data...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (testNotFound) {
    return (
      <section className="main-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="cards">
                <div className="empty-message">
                  <h5>Test Not Found</h5>
                  <p>
                    The test you're looking for doesn't exist or has been
                    deleted.
                  </p>
                  <Link to="/test-series" className="btn btn-info text-white">
                    <FontAwesomeIcon icon={faArrowLeft} className="me-1" />
                    Back to Tests
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="main-sec">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="dashboard-title">
                <h4 className="dash-head">
                  <FontAwesomeIcon icon={faEdit} className="me-2" />
                  Edit Test
                </h4>
              </div>
              <div className="custom-bredcump">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/test-series">Tests</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Edit Test
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <div className="col-lg-6 d-flex justify-content-end">
              <Link to="/test-series" className="btn btn-info text-white">
                <FontAwesomeIcon icon={faArrowLeft} className="me-1" />
                Back
              </Link>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="cards edit-usr">
                <form onSubmit={handleSubmit}>
                  {/* Basic Information */}
                  <div className="form-section">
                    <h5 className="section-title">Basic Information</h5>
                    <div className="row">
                      <div className="col-lg-12 mb-4">
                        <label htmlFor="title" className="form-label">
                          Title<sup className="text-danger">*</sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="title"
                          placeholder="Enter test title"
                          onChange={changeHandler}
                          value={formval?.title}
                        />
                      </div>
                      <div className="col-lg-4 mb-4">
                        <label htmlFor="attemptLimit" className="form-label">
                          Attempt Limit<sup className="text-danger">*</sup>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="attemptLimit"
                          placeholder="Enter Attempt Limit"
                          onChange={changeHandler}
                          value={formval?.attemptLimit}
                        />
                      </div>
                      <div className="col-lg-4 mb-4">
                        <label htmlFor="pdfDownload" className="form-label">
                          Audio upload<sup className="text-danger">*</sup>
                        </label>
                        <select
                          className="form-control"
                          name="pdfDownload"
                          id="pdfDownload"
                          onChange={changeHandler}
                          value={formval?.pdfDownload}
                        >
                          <option value={false}>NO</option>
                          <option value={true}>Yes</option>
                        </select>
                      </div>
                      <div className="col-lg-6 mb-4">
                        <label htmlFor="pdfFile" className="form-label">
                          Audio File
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          id="pdfFile"
                          name="pdfFile"
                          accept="audio/*"
                          onChange={handleFileChange}
                        />

                        {/* Show already uploaded file */}
                        {formval.pdfFile &&
                          typeof formval.pdfFile === "string" && (
                            <div className="mt-2">
                              <span className="text-muted">
                                Current File:{" "}
                                <a
                                  href={`${baseUrl}${formval.pdfFile}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {formval.pdfFile.split("/").pop()}
                                </a>
                              </span>
                            </div>
                          )}
                      </div>

                      <div className="col-lg-4 mb-4">
                        <label htmlFor="language" className="form-label">
                          Language<sup className="text-danger">*</sup>
                        </label>
                        <select
                          className="form-control"
                          name="language"
                          onChange={changeHandler}
                          value={formval?.language}
                        >
                          <option value="English">English</option>
                          <option value="Hindi">Hindi</option>
                          <option value="Bengali">Bengali</option>
                        </select>
                      </div>

                      <div className="col-lg-12 mb-4">
                        <label htmlFor="description" className="form-label">
                          Description<sup className="text-danger">*</sup>
                        </label>
                        {/* <JoditEditor
                          value={formval?.description || ""}
                          config={{
                            ...editorConfig,
                            placeholder: "Enter test description",
                          }}
                          onBlur={(value) =>
                            setFormval((prevVal) => ({
                              ...prevVal,
                              description: value,
                            }))
                          }
                        /> */}
                        <JoditEditor
                          value={formval?.description || ""}
                          config={config} // Yahan change kiya hai
                          tabIndex={1} // Optional: Focus maintain karne me help karta hai
                          onBlur={(newContent) => {
                            // Performance improve karne ke liye heavy logic onBlur par bhi shift kar sakte hain
                            // lekin agar aapko realtime chahiye toh onChange thik hai
                          }}
                          onChange={(value) => {
                            let content = value;
                            const youtubeRegex =
                              /https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{6,})[^\s]*/g;
                            content = content.replace(youtubeRegex, (match, videoId) => {
                              return `<iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
                            });

                            // State update karein
                            setFormval(prev => ({
                              ...prev,
                              description: content,
                            }));
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Test Configuration */}
                  <div className="form-section">
                    <h5 className="section-title">Test Configuration</h5>
                    <div className="row">
                      <div className="col-lg-4 mb-4">
                        <label htmlFor="duration" className="form-label">
                          Duration (minutes)<sup className="text-danger">*</sup>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="duration"
                          placeholder="60"
                          onChange={changeHandler}
                          value={formval?.duration}
                        />
                      </div>
                      <div className="col-lg-4 mb-4">
                        <label htmlFor="marks" className="form-label">
                          Total Marks<sup className="text-danger">*</sup>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="marks"
                          placeholder="100"
                          onChange={changeHandler}
                          value={formval?.marks}
                        />
                      </div>
                      <div className="col-lg-4 mb-4">
                        <label htmlFor="packageId" className="form-label">
                          Package
                        </label>
                        <select
                          className="form-control"
                          name="packageId"
                          onChange={changeHandler}
                          value={formval?.packageId}
                          disabled={fetchingPackages}
                        >
                          <option value="">Select Package</option>
                          {packages.map((pkg) => (
                            <option key={pkg._id} value={pkg?._id}>
                              {pkg?.title}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-lg-6 mb-4">
                        <label htmlFor="positiveMark" className="form-label">
                          Positive Mark<sup className="text-danger">*</sup>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="positiveMark"
                          placeholder="1"
                          onChange={changeHandler}
                          value={formval?.positiveMark}
                        />
                      </div>
                      <div className="col-lg-6 mb-4">
                        <label htmlFor="negativeMark" className="form-label">
                          Negative Mark<sup className="text-danger">*</sup>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="negativeMark"
                          placeholder="0"
                          onChange={changeHandler}
                          value={formval?.negativeMark}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Settings */}
                  <div className="form-section mt-2">
                    <div className="row">
                      <div className="col-lg-6 mb-4">
                        <label htmlFor="status" className="form-label">
                          Status<sup className="text-danger">*</sup>
                        </label>
                        <select
                          className="form-control"
                          name="status"
                          onChange={changeHandler}
                          value={formval?.status}
                        >
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 mb-4">
                    <label htmlFor="isFree" className="form-label">
                      Free Test<sup className="text-danger">*</sup>
                    </label>
                    <select
                      className="form-control"
                      name="isFree"
                      value={formval.isFree === true ? "true" : "false"}
                      onChange={(e) =>
                        setFormval((prev) => ({
                          ...prev,
                          isFree: e.target.value === "true",
                        }))
                      }
                    >
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                  <div className="col-lg-12 text-center mt-4">
                    <button
                      type="submit"
                      className="btn btn-for-add text-white"
                      disabled={loading}
                    >
                      {loading && <div className="loading-spinner"></div>}
                      <FontAwesomeIcon icon={faSave} className="me-2" />
                      {loading ? "Updating..." : "Update Test"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>
        {`
                    em{
                        display: none !important; 
                    }
                    .ql-align-center{
                        display: none !important;
                    }
                    .ql-indent-1{
                        display: none !important;
                    }
                    .jodit-status-bar__item.jodit-status-bar__item-right{
                      display:none !important;
                    }
                `}
      </style>
    </>
  );
}
